export default __webpack_public_path__ + "static/media/emptyWishlist.98ae7af0.svg";